// 去掉 AI 生成 markdown 首尾包裹的 `---`，避免被 react-markdown 解析为 setext H2
export function stripMarkdownDividers(text: string): string {
  if (!text) return text;
  return text
    .replace(/^\s*---+[ \t]*\r?\n/, '')
    .replace(/\r?\n[ \t]*---+\s*$/, '');
}

export function copyText(text, callback) {
  // text: 要复制的内容， callback: 回调
  const tag = document.createElement('textarea');
  tag.setAttribute('id', 'cp_hgz_input');
  tag.setAttribute('readOnly', 'readOnly');
  tag.value = text;
  document.getElementsByTagName('body')[0].appendChild(tag);
  document.getElementById('cp_hgz_input').select();
  document.execCommand('copy');
  document.getElementById('cp_hgz_input').remove();
  if (callback) {
    callback(text);
  }
}
